import React from "react";
import PropTypes from "prop-types";
import Article from "../../models/Article";
import ExpandableList from "../../../atoms/ExpandableList";
import Btn from "../../../atoms/Btn";

function PublicationAuthors({ article, isExpandable }) {
  if (!article?.authors?.length) return null;

  if (!article) return null;

  return isExpandable ? (
    <ExpandableList
      items={article?.authors || []}
      limit={4}
      limitAllowance={1}
      ListRenderer={({ items }) => <span>{items.join(", ")}</span>}
      BtnRenderer={({ hiddenItemCount, toggle, isExpanded }) => (
        <div className="tw-mx-2 tw-inline-block">
          <Btn
            className="tw-border tw-text-2xs tw-border-blueGray-300 tw-bg-blueGray-100 tw-px-2"
            onSubmit={toggle}
          >
            {isExpanded ? "less..." : `+ ${hiddenItemCount}`}
          </Btn>
        </div>
      )}
    />
  ) : (
    <div className="tw-truncate">
      Author{article.authors.length === 1 ? ": " : "s: "}
      {article.authors.join(", ")}
    </div>
  );
}

PublicationAuthors.propTypes = {
  isExpandable: PropTypes.bool,
  article: PropTypes.instanceOf(Article),
};

PublicationAuthors.defaultProps = {
  isExpandable: true,
  article: null,
};

export default PublicationAuthors;
